<i18n locale="en">
  {
    "cta": "Add Item"
  }
</i18n>
<template>
  <PreviewSheet class="menu-item-card" radius="medium">
    <div
      class="menu-item-card__content flex-col gap-4"
      :style="{
        borderRadius: cardBorderRadius,
      }"
    >
      <div
        class="menu-item-card__image"
        :style="{
          backgroundImage: `url(${item.image})`,
          borderRadius: imageBorderRadius,
        }"
      >
        <div class="absolute bottom-2 right-2">
          <button
            class="flex items-center h-12 w-12 justify-center px-3"
            :style="buttonStyles"
            :aria-label="t('cta')"
            :title="t('cta')"
          >
            <PhPlus size="20" weight="bold" :style="{ color: iconTextColor }" />
          </button>
        </div>
      </div>
      <div class="menu-item-card__footer flex-col gap-4 justify-between">
        <div class="flex-col gap-1">
          <PreviewTypography
            :text="item.displayName ?? item.name"
            variant="titleLarge"
            color="primary"
            class="menu-item-card__title-text"
          />
        </div>
      </div>
    </div>
  </PreviewSheet>
</template>
<script lang="ts" setup>
import { type Olympus } from '@owner/olympus-client'
import { PhPlus } from '@phosphor-icons/vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useMergedTheme } from '@/lib/builder/public/preview/mixins/useMergedThemeComp'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'

const { t } = useI18n()

const mergedTheme = useMergedTheme()

const imageBorderRadius = computed(() => {
  return mergedTheme.value != null
    ? `${mergedTheme.value.borderRadius.small}rem`
    : 0
})

const cardBorderRadius = computed(() => {
  return mergedTheme.value != null
    ? `${mergedTheme.value.borderRadius.medium}rem`
    : 0
})

const buttonBackgroundColor = computed(() => {
  return mergedTheme.value?.colors?.background?.primary || 'transparent'
})

const iconTextColor = computed(() => {
  return mergedTheme.value?.colors?.text?.primary || '#000000'
})

const controlBorderRadius = computed(() => {
  return mergedTheme.value != null
    ? `${mergedTheme.value.borderRadius.control}rem`
    : '0.375rem'
})

const buttonStyles = computed(() => ({
  backgroundColor: buttonBackgroundColor.value,
  borderRadius: controlBorderRadius.value,
}))

defineProps<{
  item: Olympus.Menu.Item
}>()
</script>
<style lang="scss" scoped>
.menu-item-card {
  position: relative;

  &__image {
    position: relative;
    width: 288px;
    height: 288px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &__footer {
    flex-grow: 1;
    padding: 0 8px;
  }

  &__title-text {
    -webkit-line-clamp: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
}
</style>
